export function groupTabLinks(array) {
  if (!array || !array.links.length || !array.title) return null;
  const group = [];
  for (let i = 0; i < array.links.length; i += 5) {
    group.push(array.links.slice(i, i + 5));
  }
  const result = {
    title: array.title,
    links: group
  };
  return result;
}